import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FileModel } from '../../shared.model';

@Component({
  standalone: false,
  templateUrl: 'view-file.component.html',
  styleUrls: ['view-file.component.scss']
})
export class ViewFileComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: FileModel,
    public dialogRef: MatDialogRef<ViewFileComponent>) { }

  onClose() {
    this.dialogRef.close();
  }
}
